// Project statuses (English). Stored values: in_progress | in_review | finished.
// "Finished" is also applied automatically after 14 days without logged hours (computed by the server;
// the API already returns the effective status everywhere).
export const PROJECT_STATUSES = [
  { value: 'in_progress', label: 'In progress', cls: 'bg-blue-100 text-blue-800' },
  { value: 'in_review', label: 'In review', cls: 'bg-yellow-100 text-yellow-800' },
  { value: 'finished', label: 'Done', cls: 'bg-green-100 text-green-800' },
];

const LEGACY = { u_izradi: 'in_progress', na_reviziji: 'in_review', zavrseno: 'finished' };

export const normalizeProjectStatus = (value) => {
  if (PROJECT_STATUSES.some((s) => s.value === value)) return value;
  return LEGACY[value] || 'in_progress';
};

export const projectStatusMeta = (value) =>
  PROJECT_STATUSES.find((s) => s.value === normalizeProjectStatus(value));
